import { useGlobalModal } from "components/GlobalModal/useGlobalModal";
import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";

import { FeedbackForm } from "./FeedbackForm";

export const useFeedbackGlobalModal = () => {
  const actions = useGlobalModal(FeedbackForm);

  useRegisterCommands(
    [
      {
        id: "codesandbox.feedback",
        name: "Submit Feedback",
        perform: () => {
          actions.open();
        },
        section: "CodeSandbox",
      },
    ],
    [],
  );

  return actions;
};
